import { Routes } from '@angular/router';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FlowFormComponent } from './components/interactive-step/flow-form/flow-form.component';
import { StartFlowComponent } from './components/interactive-step/start-flow/start-flow.component';
import { TaskFormComponent } from './components/interactive-step/task-form/task-form.component';
import { SuccessPageComponent } from './components/success-page/success-page.component';
import { FormType } from './models/form-type.model';

export const routes: Routes = [
  {
    path: ':tenantId/displayTaskAsGuest',
    component: TaskFormComponent,
    data: { isGuest: true },
  },
  {
    path: ':tenantId/displayTask',
    component: TaskFormComponent,
    data: { isGuest: false },
  },
  {
    path: ':tenantId/displayFlowForm',
    component: FlowFormComponent,
  data: { isGuest: false, defaultScopeMode: FormType.Form },
  },
  {
    path: ':tenantId/editFlowForm',
    component: FlowFormComponent,
  data: { isGuest: false, defaultScopeMode: FormType.EditForm },
  },
  {
    path: ':tenantId/startAsGuest',
    component: StartFlowComponent,
    data: { isGuest: true },
  },
  {
    path: ':tenantId/start',
    component: StartFlowComponent,
    data: { isGuest: false },
  },
  { path: 'error', component: ErrorPageComponent },
  { path: 'success', component: SuccessPageComponent },
  { path: '**', redirectTo: '/error?code=404' },
];
